import { NoQuizzesIllustration } from '../../illustrations';
import { SurfaceEmptyState } from '../SurfaceEmptyState';
import type { QuizzesEmptyStateProps } from './QuizzesEmptyState.types';

/**
 * The quizzes list's empty-state card — the quiz-specific face of
 * {@link SurfaceEmptyState}, which owns the card, spacing and type ramp every
 * deck surface's empty state shares.
 *
 * All this adds is the ONE quiz-specific decision: which artwork, and when. A
 * TRUE empty deck gets the "no quizzes" illustration; a list filtered down to
 * nothing stays plain — the deck HAS history, it is just filtered away, and
 * repeating the "no quizzes yet" artwork there reads as data loss.
 *
 * Labels arrive pre-translated (the DS carries no i18n).
 */
export function QuizzesEmptyState({
  illustrated = false,
  title,
  description,
  action,
  className,
  testID,
}: QuizzesEmptyStateProps) {
  return (
    <SurfaceEmptyState
      artwork={illustrated ? <NoQuizzesIllustration /> : undefined}
      title={title}
      description={description}
      action={action}
      className={className}
      testID={testID}
    />
  );
}
(QuizzesEmptyState as { displayName?: string }).displayName = 'QuizzesEmptyState';
